import React, { useState, useEffect } from 'react';
import DetailIcon from '@/common/detail-icon';
import MyLazyComponent from '@/common/lazy-load';
import './index.less';
import doLog from '@/common/log';
import PageStore from '@/stores/page';
interface PropType {
  i18n: DetailTypes.i18n;
  quickShow?: boolean;
}
export default function Index(props: PropType & SemiTypes.Root) {
  const {
    assuranceList = [],
    action,
    title,
    titleImage,
    tailLogo,
    tailText,
    content,
    quickShow = false,
  } = props;
  useEffect(() => {
    doLog('/sc.details.halfdelegated_TA_new', '', 'EXP');
  }, []);

  const [visible, setVisible] = useState(false);
  if (!action) return null;
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;
  // TA+弹窗
  const TaDialog = MyLazyComponent(() => import(/* webpackChunkName: "ta-dialog" */ './ta-dialog'));
  return (
    <div className="ta-semi">
      {quickShow ? (
        <h3>
          <div>
            <span>{title}</span>
            {titleImage && <img src={titleImage} alt={title} />}
          </div>
        </h3>
      ) : (
        <h3 onClick={() => setVisible(true)}>
          <div className="ta-header">
            <div className="ta-item">
              <span className="title">{title}</span>
              {!content && titleImage && <img src={titleImage} alt={title} />}
            </div>
            {content && (
              <div
                className="ta-item other"
                dangerouslySetInnerHTML={{
                  __html: `${content}  <img src="${titleImage}" />`,
                }}
              ></div>
            )}
          </div>
          <DetailIcon symbol="icon-right" className="detail-symbol" />
        </h3>
      )}
      <div className="semi-list">
        {assuranceList.map((item, index) => (
          <div className="semi-item" key={index}>
            <h4
              style={{
                color: `#${item.titleColor}`,
              }}
            >
              <img src={item.icon} />
              <div>
                <span>{item.titleText}</span>
                <img src={item.titleImage} />
              </div>
            </h4>
            <div>{item.descriptionList.map((item) => item)}</div>
          </div>
        ))}
      </div>
      {tailText && (
        <div className="semi-footer">
          {tailText}
          {tailLogo && <img src={tailLogo} />}
        </div>
      )}
      {isLoaded ? <TaDialog url={action} visible={visible} setVisible={setVisible} /> : null}
    </div>
  );
}
